<!-- router outlet to load all pages -->

<router-outlet></router-outlet>

<!-- common loder for pages -->
<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-climbing-dot" [fullScreen]="true">
    <p style="color:white">Loading...</p>
</ngx-spinner> -->

<!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 30px; color: white">Loading . . .</p>
</ngx-spinner> -->

<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner> -->

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "cube-transition" [fullScreen] = "true">
    <p style="color: white" > Loading... </p>
</ngx-spinner>

<!-- <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "triangle-skew-spin" [fullScreen] = "true">
    <p style="color: white" > Loading... </p>
</ngx-spinner> -->

<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" [fullScreen]="true">
    
  <div class="lottie-iframe-container">
    <iframe 
      src="https://lottie.host/embed/32509f60-7f23-4b6e-bac6-ecb36826eb2b/VLA6KMrSFV.lottie"
      style="border: none; width: 220px; height: 220px;margin-top: -20px;"
      allowfullscreen>
    </iframe>
  </div>
  
</ngx-spinner> -->
